import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/doubleQuotes.png'


const _withScopeId = n => (_pushScopeId("data-v-abd91786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "brand_div" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "brand_section_title" }, "书籍推荐", -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { id: "brand_book_title" }
const _hoisted_5 = { id: "box_bg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "box_icon",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoxWithBtn = _resolveComponent("BoxWithBtn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("img", {
      src: _ctx.item.img,
      id: "brand_book_img"
    }, null, 8, _hoisted_3),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.title), 1),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.ps, (pdes, pi) => {
        return (_openBlock(), _createElementBlock("div", {
          id: "box_des",
          key: `box_p_${pi}`
        }, _toDisplayString(pdes), 1))
      }), 128)),
      (_ctx.item.link)
        ? (_openBlock(), _createBlock(_component_BoxWithBtn, {
            key: 0,
            text: _ctx.item.btnText,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDetail(_ctx.item.link)))
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}